// Translations for the Apnea Coach Manager application
// Supports English (en) and French (fr)

const translations = {
  en: {
    // App Header
    appTitle: "Apnea Coach Manager",
    appSubtitle: "Freediving Training and Competition Manager by https://apneeaquarius.ca/",
    
    // Authentication
    connect: "Connect",
    disconnect: "Disconnect",
    signIn: "Sign In",
    signInTitle: "Sign In to Apnea Coach Manager",
    signInDescription: "Enter your credentials to access all features.",
    username: "Username",
    password: "Password",
    enterUsername: "Enter your username",
    enterPassword: "Enter your password",
    cancel: "Cancel",
    invalidCredentials: "Invalid username or password",
    administrator: "Administrator",
    user: "User",
    viewer: "Viewer",
    
    // Navigation
    dashboard: "Dashboard",
    contests: "Contests",
    competitions: "Competitions",
    registrations: "Registrations",
    liveEvents: "Live Events",
    eventResults: "Event Results",
    career: "Career",
    freedivers: "Freedivers",
    followUp: "Follow Up",
    performanceComparison: "Performance Comparison",
    trainingSessions: "Training Sessions",
    aquaticInfrastructure: "Aquatic Infrastructure",
    
    // Dashboard
    dashboardTitle: "May the Freedive, Be With You!",
    dashboardSubtitle: "Your comprehensive platform for managing freediving sport activities",
    totalCompetitions: "Total Competitions",
    registeredFreedivers: "Registered Freedivers",
    eventRegistrations: "Event Registrations",
    bulkRegistration: "Bulk Registration",
    bulkRegistrationDesc: "Select a competition and discipline, then drag & drop or click + to add freedivers.",
    singleRegistration: "Quick Registration",
    inscritList: "Registered",
    availableFreedivers: "Available freedivers",
    searchByName: "Search by name or first name...",
    activeCompetitions: "Active Competitions",
    welcomeTitle: "Welcome to Apnea Coach Manager",
    welcomeDescription: "Your comprehensive platform for managing freediving competitions, tracking athlete performance, and building training programs.",
    competitionManagement: "Competition Management",
    competitionManagementDesc: "Create and manage competitions with multiple event types, real-time scoring, and live event monitoring.",
    athleteTracking: "Athlete Tracking",
    athleteTrackingDesc: "Register freedivers, track their certifications, and monitor their performance history over time.",
    performanceFollowUp: "Performance Follow-Up",
    performanceFollowUpDesc: "Record training performances with detailed metrics, coach validation, and automatic ranking.",
    trainingSessionsDesc: "Build custom training programs with exercises, templates, and session planning tools.",
    liveEventsDesc: "Real-time judge interface with countdown timers, RP entry, and automatic result calculation.",
    supportedEvents: "Supported Events",
    
    // Freedivers
    freediversTitle: "Freedivers",
    registerFreediver: "Register Freediver",
    addFreediver: "Add a Freediver",
    addFreediverDescription: "Enter the new freediver's information below.",
    editFreediver: "Edit Freediver",
    updateFreediverDetails: "Update the freediver's information below.",
    validFrom: "Valid from",
    validUntil: "Valid until",
    valid: "Valid",
    expired: "Expired",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    nationality: "Nationality",
    gender: "Gender",
    male: "Male",
    female: "Female",
    dateOfBirth: "Date of Birth",
    placeOfBirth: "Place of Birth",
    certificationAgency: "Certification Agency",
    certificationLevel: "Certification Level",
    experienceLevel: "Experience Level",
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
    elite: "Elite",
    coachTrainer: "Coach/Trainer",
    markAsCoach: "Coach/Trainer",
    photo: "Photo",
    uploadPhoto: "Upload Photo",
    changePhoto: "Change Photo",
    removePhoto: "Remove Photo",
    save: "Save",
    delete: "Delete",
    confirmDelete: "Are you sure you want to delete this?",
    
    // Follow Up
    followUpTitle: "Follow Up - Freediver Tracking",
    selectFreediverToTrack: "Select Freediver to Track",
    searchFreediver: "Search freediver...",
    addPerformance: "Add Performance",
    editPerformance: "Edit Performance",
    performanceSummaryByType: "Performance Summary by Type",
    performanceHistory: "Performance History",
    noPerformancesYet: "No performances recorded yet. Click \"Add Performance\" to start tracking.",
    performanceDate: "Performance Date",
    performanceType: "Performance Type",
    location: "Location",
    poolType: "Pool Type",
    distance: "Distance",
    distanceMeters: "Distance (meters)",
    durationMinutes: "Duration (Minutes)",
    durationSeconds: "Duration (Seconds)",
    duration: "Duration",
    reps: "Reps",
    prebuilt: "Prebuilt",
    type: "Type",
    actions: "Actions",
    coachTrainerSelect: "Coach/Trainer",
    noCoachSelected: "No coach selected",
    noCoachesAvailable: "No coaches available. Mark a freediver as \"Coach/Trainer\" in the Freedivers section.",
    comments: "Comments/Observations",
    preparationProtocol: "Preparation Protocol",
    yrsShort: "yrs",
    yearsOld: "years old",
    perfSummaryByType: "Performance Summary by Type",
    gold: "Gold",
    silver: "Silver",
    bronze: "Bronze",
    addNewPerformance: "Add New Performance",
    updatePerfDetails: "Update the performance details.",
    recordNewPerf: "Record a new performance for tracking.",
    locationPlaceholder: "e.g., Paris Swimming Center",
    distancePlaceholder: "e.g., 150",
    coachTrainer: "Coach/Trainer",
    selectCoach: "Select a coach/trainer",
    commentsObservations: "Comments/Observations",
    notesPlaceholder: "Notes about the performance...",
    protocolPlaceholder: "Detailed preparation protocol...",
    updatePerformance: "Update Performance",
    
    // Performance Comparison
    compareFreedivers: "Compare Freedivers",
    progressTrend: "Progress Trend",
    selectFreediversMax4: "Select Freedivers (max 4)",
    selectFreediver: "Select Freediver",
    chooseFreediver: "Choose freediver...",
    fromDate: "From Date",
    toDate: "To Date",
    selectFreediversToCompare: "Select Freedivers to Compare",
    selectUpTo4Freedivers: "Select up to 4 freedivers to compare their performances side-by-side.",
    selectFreediverForTrend: "Select a Freediver",
    selectFreediverToAnalyze: "Select a freediver to analyze their performance trends over time.",
    progressOverTime: "Progress Over Time",
    bestPerformances: "Best Performances",
    noDataForSelectedFilters: "No data available for the selected filters.",
    best: "Best",
    average: "Average",
    totalPerformances: "Performances",
    firstRecord: "First Record",
    latestRecord: "Latest Record",
    personalBest: "Personal Best",
    improvement: "Improvement",
    change: "Change",
    performanceTrend: "Performance Trend",
    date: "Date",
    value: "Value",
    
    // Aquatic Infrastructure
    aquaticInfrastructureTitle: "Aquatic Infrastructure",
    addPoolLocation: "Add Pool Location",
    editPoolLocation: "Edit Pool Location",
    noPoolLocationsYet: "No Pool Locations Yet",
    addFirstPoolLocation: "Add your first aquatic infrastructure to start managing pool locations.",
    shortName: "Short Name",
    longName: "Long Name",
    organization: "Organization",
    buildingName: "Building Name",
    poolSpecifications: "Pool Specifications",
    poolLength: "Pool Length (m)",
    numberOfLanes: "Number of Lanes",
    minDepth: "Min Depth (m)",
    maxDepth: "Max Depth (m)",
    maxCapacity: "Max Capacity",
    address: "Address",
    streetNumber: "Number",
    street: "Street",
    streetType: "Type",
    city: "City",
    postalCode: "Postal Code",
    province: "Province/State",
    country: "Country",
    logo: "Logo",
    uploadLogo: "Upload Logo",
    changeLogo: "Change Logo",
    websiteUrl: "Website URL",
    visitWebsite: "Visit Website",
    
    // Training Sessions
    trainingSessionsTitle: "Training Sessions",
    newTrainingSession: "New Training Session",
    editTrainingSession: "Edit Training Session",
    createNewTrainingSession: "Create New Training Session",
    sessionName: "Session Name",
    discipline: "Discipline",
    coachInstructorName: "Coach/Instructor",
    selectCoach: "Select a coach...",
    trainingTemplate: "Training Template (Optional)",
    choosePrebuiltTemplates: "Choose from Pre-built Templates",
    selectTemplateOrCustom: "Select a training template or create custom",
    createCustomSession: "Create Custom Session",
    trainingLocation: "Training Location",
    quickFillFromSavedPools: "Quick Fill from Saved Pool Locations",
    enterManually: "Enter Manually",
    selectPoolOrEnterManually: "Select a saved pool location to auto-fill the details below, or choose \"Enter Manually\" to fill in custom values.",
    buildingFacilityName: "Building/Facility Name",
    hostOrganization: "Host Organization",
    streetAddress: "Street Address",
    trainingBlocks: "Training Blocks",
    totalDistance: "Total Distance",
    listView: "List View",
    calendarView: "Calendar View",
    // Document Attachments
    documentAttachments: "Document Attachments",
    addAttachment: "Add Attachment",
    attachFiles: "Attach Files",
    allowedFileTypes: "Allowed: Excel (.xlsx, .xls), Word (.docx, .doc), PDF",
    invalidFileType: "Invalid file type",
    fileTooLarge: "File too large",
    noAttachments: "No attachments",
    removeAttachment: "Remove",
    downloadAttachment: "Download",
    attachedFiles: "Attached Files",
    
    // Template Management
    manageTemplates: "Templates",
    createTemplate: "Create Custom Template",
    editTemplate: "Edit Template",
    newTemplate: "New Template",
    saveTemplate: "Save Template",
    updateTemplate: "Update Template",
    yourTemplates: "Your Custom Templates",
    templateName: "Template Name",
    confirmDelete: "Are you sure you want to delete this?",
    
    // Participant Management
    participants: "Participants",
    manageParticipants: "Manage Participants",
    currentParticipants: "Current Participants",
    addParticipant: "Add Participant",
    noParticipants: "No participants assigned",
    noParticipantsSelected: "No participants selected",
    allFreediversAssigned: "All freedivers are already assigned",
    
    // Inline Editing
    quickEdit: "Quick Edit",
    doubleClickToEdit: "Double-click to quick edit",
    
    // Session Builder
    sessionBuilder: "Session Builder",
    sessionTimeline: "Session Timeline",
    addBlock: "Add Block",
    blocks: "blocks",
    noBlocksYet: "No blocks yet",
    addBlocksHint: "Click the buttons above to add training blocks, or add exercises from the library",
    clearAll: "Clear All",
    saveSession: "Save Session",
    enterSessionName: "Enter session name...",
    sessionSaved: "Session saved successfully!",
    errorSavingSession: "Error saving session. Please try again.",
    confirmClearAll: "Are you sure you want to clear all blocks?",
    sessionNameRequired: "Session name is required",
    addBlocksFirst: "Please add at least one block",
    filterByType: "Filter by type",
    noExercisesFound: "No exercises found",
    sessionNotesPlaceholder: "Add any notes for this training session...",
    
    // PDF Parsing
    uploadTrainingPdf: "Upload Training PDF",
    parsePdf: "Parse PDF",
    parsingPdf: "Parsing PDF...",
    pdfParsed: "PDF Parsed Successfully",
    pdfParseError: "Error parsing PDF",
    exercisesFound: "exercises found",
    blocksDetected: "blocks detected",
    importExercises: "Import Exercises",
    importSessions: "Import Sessions",
    importAllBlocks: "Import All Blocks",
    previewParsedContent: "Preview Parsed Content",
    rawTextPreview: "Raw Text Preview",
    noExercisesExtracted: "No exercises could be extracted from this file",
    selectPdfFile: "Select a PDF file",
    dropPdfHere: "Drop PDF here or click to browse",
    pdfFilesOnlyMax10: "PDF files only (max 10MB)",
    parsedExercises: "Parsed Exercises",
    parsedBlocks: "Parsed Blocks",
    addParsedToSession: "Add to Session",
    importPdfExercises: "Import from PDF",
    closePreview: "Close Preview",
    totalExercises: "Total Exercises",
    // Excel parsing
    importFromFile: "Import from File",
    parsingFile: "Parsing file...",
    fileParsed: "File Parsed Successfully",
    fileParseError: "Error parsing file",
    pdfOrExcelOnly: "PDF or Excel files only (max 10MB)",
    excelParsed: "Excel Parsed Successfully",
    
    // Competitions
    competitionsTitle: "Competitions",
    newCompetition: "New Competition",
    editCompetition: "Edit Competition",
    createNewCompetition: "Create New Competition",
    competitionName: "Competition Name",
    startDate: "Start Date",
    endDate: "End Date",
    lanes: "Lanes",
    federation: "Federation",
    maxFreedivers: "Max Freedivers",
    organizer: "Organizer",
    contactName: "Contact Name",
    contactEmail: "Contact Email",
    contactPhone: "Contact Phone",
    contactAddress: "Contact Address",
    description: "Description",
    competitionLogo: "Competition Logo",
    selectLogo: "Select Logo",
    updateCompetition: "Update Competition",
    deleteCompetition: "Delete Competition",
    competitionDetails: "Competition Details",
    registrationsClosed: "Registrations Closed",
    registrationsOpen: "Registrations Open",
    
    // Registrations
    registrationsTitle: "Event Registrations",
    createEventRegistration: "Create Event Registration",
    editEventRegistration: "Edit Event Registration",
    selectCompetition: "Select Competition",
    selectEvents: "Select Events",
    announcedPerformance: "Announced Performance",
    officialTop: "Official Top",
    countdownToOfficialTop: "Countdown To Official TOP",
    warmUpTime: "Warm-up Time",
    registrationStatus: "Status",
    pending: "Pending",
    confirmed: "Confirmed",
    withdrawn: "Withdrawn",
    disqualified: "Disqualified",
    
    // Training Sessions Form
    trainingDate: "Training Date",
    startTime: "Start Time",
    endTime: "End Time",
    additionalNotes: "Additional Notes",
    saveAsTemplate: "Save as template for reuse",
    templateName: "Template Name",
    createSession: "Create Session",
    updateSession: "Update Session",
    cancelSession: "Cancel",
    cloneSession: "Clone",
    deleteSession: "Delete",
    trainingProgram: "Training Program",
    noExerciseBlocks: "No exercise blocks defined. Add blocks above or select a template.",
    details: "Details",
    poolInfo: "Pool Info",
    lanes: "lanes",
    depth: "Depth",
    minutes: "minutes",
    
    // Exercise Blocks
    exerciseBlocks: "Exercise Blocks",
    addBlock: "Add Block",
    blockName: "Block Name",
    blockDuration: "Duration (minutes)",
    blockNotes: "Block Notes",
    exercises: "Exercises",
    addExercise: "Add Exercise",
    exerciseName: "Exercise Name",
    exerciseType: "Exercise Type",
    exerciseDescription: "Exercise Description",
    exerciseInstructions: "Instructions",
    repetitions: "Repetitions",
    restSeconds: "Rest (seconds)",
    noExercisesInBlock: "No exercises in this block",
    
    // Custom Exercise Library
    exerciseLibrary: "Exercise Library",
    customExercises: "Custom Exercises",
    createCustomExercise: "Create Custom Exercise",
    editCustomExercise: "Edit Custom Exercise",
    myExercises: "My Exercises",
    publicExercises: "Public Exercises",
    prebuiltExercises: "Pre-built Exercises",
    exerciseCategory: "Category",
    targetDiscipline: "Target Discipline",
    difficultyLevel: "Difficulty Level",
    makePublic: "Make Public",
    publicExerciseHint: "Public exercises are visible to all users",
    noCustomExercises: "No custom exercises yet. Create your first one!",
    addToSession: "Add to Session",
    duplicateExercise: "Duplicate",
    exerciseDetails: "Exercise Details",
    selectFromLibrary: "Select from Library",
    searchExercises: "Search exercises...",
    warmUp: "Warm-up",
    breathHold: "Breath Hold",
    dynamic: "Dynamic",
    static: "Static",
    recovery: "Recovery",
    coolDown: "Cool Down",
    technique: "Technique",
    
    // Live Events
    liveEventsTitle: "Live Events",
    liveEventManagement: "Live Event Management",
    cancelEvent: "Cancel Event",
    confirm: "Confirm",
    eventSessions: "Event Sessions",
    noEventSessions: "No event sessions found",
    importExcelToCreate: "Import an Excel file to create event sessions",
    refreshSessions: "Refresh Sessions",
    globalEventTimer: "Global Event Timer",
    disciplineEvent: "Discipline Event",
    resetToZero: "Reset to Zero",
    confirmResetTimer: "Reset the event timer to zero? This will only reset the display timer, not the event data.",
    restartEvent: "Restart Event",
    confirmRestartEvent: "Restart the event? All performances will be cleared and timers will restart from now.",
    stopEvent: "Pause Event",
    pauseEvent: "Pause Event",
    resumeEvent: "Resume Event",
    finishEvent: "Finish Event",
    quickEntry: "Quick Entry — Remaining Athletes",
    quickEntryDesc: "Enter results for the remaining athletes. Score is calculated automatically per agency rules (AIDA/CMAS).",
    confirmFinishEvent: "Finish the event? All performances will be saved as career performances. Continue?",
    eventFinished: "Event finished. Performances saved to career tracking.",
    fullName: "Full name",
    transit: "Transit",
    official: "Official",
    eventStarted: "Event Started",
    paused: "PAUSED",
    addPenalty: "Add",
    avgSpeed: "Avg. Speed",
    configureZones: "Configure Zones",
    configureZonesDesc: "Configure performance lanes and zone assignments for this competition.",
    numberOfZones: "Number of zones",
    zone: "Zone",
    zone1Desc: "Sequential — one athlete at a time",
    zone2Desc: "Parallel — two athletes start at the same OT",
    poolDiagram: "Pool diagram",
    lanes: "lanes",
    lane: "Lane",
    unassigned: "unassigned",
    performanceLane: "Performance lane",
    warmupLane: "Warm-up lane",
    transitLane: "Transit lane",
    assignedUsers: "Assigned operators",
    noUsersToAssign: "No users to assign — create accounts first.",
    saveConfiguration: "Save configuration",
    rolePalette: "Role palette",
    dragToLane: "(drag onto a lane)",
    dropRoleHere: "drop a role here",
    clearLane: "Clear lane",
    resetAll: "Reset all",
    perfLaneRequired: "Each zone must have a performance lane.",
    perfLaneConflict: "Performance lane must be unique per zone. Move conflicting role to a different lane.",
    dragDropInstructions: "Drag the role badges below onto the pool lanes. Performance lanes must be unique; warmup/transit can be shared.",
    sessionPreview: "Session preview",
    sessionPreviewDesc: "— see what the running order will look like",
    runPreview: "Run preview",
    selectEventToPreview: "Select an event type to preview.",
    noRegistrations: "No registrations yet",
    athletes: "Athletes",
    otSlots: "OT slots",
    simultaneousStarts: "Simultaneous",
    totalDuration: "Total duration",
    previewNote: "Preview only — running order will be generated when an event session is created.",
    createSessionFromPreview: "Happy with the preview? Create the session directly:",
    createSession: "Create session",
    newLiveSession: "New live session",
    sessionName: "Session name",
    date: "Date",
    time: "Time",
    intervalDuration: "Interval per passage",
    preparationDuration: "Preparation/warm-up",
    createSessionNote: "Saving will persist your zone configuration and immediately create the live session.",
    createNow: "Create now",
    sessionNameRequired: "Session name is required.",
    sessionDateTimeRequired: "Start date and time are required.",
    sessionCreatedOK: "Session created successfully.",
    sessionCreateFailed: "Failed to create session: ",
    duplicate: "Duplicate",
    copyShort: "copy",
    duplicateCompetitionPrompt: "New competition name:",
    competitionDuplicated: "Competition duplicated",
    duplicateFailed: "Failed to duplicate",
    performance: "PERF",
    transit: "TRANSIT",
    zoneControl: "Zone control",
    zones: "zones",
    viewingZone: "Viewing",
    preferredZone: "PREFERRED",
    you: "YOU",
    zoneFree: "Free — anyone can take control",
    releaseControl: "Release",
    takeControl: "Take Control",
    forceTakeOverPrompt: "Force take over?",
    showAll: "Show all",
    view: "View",
    finishAndSave: "Finish & Save",
    confirmFinishShort: "Yes, Finish Event",
    allAthletesCompleted: "All athletes have completed their performances.",
    clickFinishToValidate: "Click 'Finish & Save' to close the event and save all performances to career tracking.",
    athletesRemaining: "remaining",
    quickEntered: "quick-entered",
    toBeEntered: "not entered",
    willSaveCareerNote: "All completed performances will be saved to athletes career tracking automatically.",
    errorFinishingEvent: "Failed to finish event:",
    back: "Back",
    briefingDuration: "Briefing Duration",
    warmupDuration: "Warmup Duration",
    passageDuration: "Passage Duration",
    liveEvent: "Live Event",
    timeToNextContestant: "Time to Next Contestant",
    currentContestant: "Current Contestant",
    totalPassages: "Total Passages",
    remaining: "Remaining",
    currentLane: "Current Lane",
    runningOrder: "Running Order",
    contestantOrderForEvent: "Contestant order for this event",
    noRunningOrderAvailable: "No running order available",
    printPDF: "Print PDF",
    warmup: "Warm-up",
    sex: "Sex",
    contestant: "Contestant",
    announced: "Announced",
    yellowCard: "Yellow",
    redCard: "Red",
    startSession: "Start Session",
    stopSession: "Stop Session",
    pauseCountdown: "Pause Countdown",
    resumeCountdown: "Resume Countdown",
    startPerformance: "Start Performance",
    endPerformance: "End Performance",
    performanceDuration: "Duration",
    stopPerformance: "Stop Performance",
    saveResult: "Save Result",
    nextFreediver: "Next Freediver",
    currentFreediver: "Current Freediver",
    nextUp: "Next",
    nextContestant: "Next contestant",
    skipToResults: "Skip to Results",
    skipToOfficialCountdown: "Skip to Official Countdown",
    waitingForOT: "Waiting for OT",
    performanceInProgress: "PERFORMING",
    validationByJudges: "Performance in validation by Judges",
    performanceSaved: "Performance Saved",
    enterResults: "ENTER RESULTS",
    enterResultsBelow: "Enter results below",
    allPassagesCompleted: "All passages completed!",
    performanceResults: "Performance Results",
    durationOfEvent: "Duration of the Event",
    timeBeforeProtest: "Time Before Protest",
    protestPeriodInProgress: "Protest Period in Progress",
    protestPeriodEnded: "Protest period has ended",
    closeThisEvent: "Close This Event",
    eventClosed: "Event Closed",
    eventTerminated: "Event Completely Terminated!",
    terminateEvent: "Terminate Event",
    resultsAreFinal: "Results are final",
    closed: "Closed",
    timeLimit: "Time limit",
    lastSavedPerformance: "Last Saved Performance",
    warmUp: "Warm Up",
    transition: "Transition",
    realizedPerformance: "Realized Performance (RP)",
    penalties: "Penalties",
    card: "Card",
    white: "White",
    yellow: "Yellow",
    red: "Red",
    selectEventSession: "Select Event Session",
    noActiveSession: "No Active Session",
    createEventSessionsHint: "Create event sessions from the Registrations tab to start live events.",
    sessionInProgress: "Session In Progress",
    passageList: "Passage List",
    passageOrder: "Passage Order",
    waitingRoom: "Waiting Room",
    inProgress: "In Progress",
    completed: "Completed",
    unknown: "Unknown",
    
    // Event Results
    eventResultsTitle: "Event Results",
    eventResultsRankings: "Event Results & Rankings",
    viewFinalResults: "View final results and rankings for completed and closed competitions.",
    selectCompetitionToView: "Please select a competition to view results.",
    noCompletedEvents: "No completed or closed events found for this competition.",
    viewRankings: "View Rankings",
    downloadPDF: "Download PDF",
    noResultsAvailable: "No results available for this event.",
    score: "Score",
    exportPdf: "Export PDF",
    exportExcel: "Export Excel",
    exportedOn: "Exported on",
    filterByGender: "Filter by Gender",
    all: "All",
    male: "Men",
    female: "Women",
    rank: "Rank",
    points: "Points",
    finalScore: "Final Score",
    
    // Expiring Certificates
    expiringCertificates: "Expiring Medical Certificates",
    expiringCertificatesDesc: "The following freedivers have medical certificates expiring within 30 days or already expired:",
    expires: "Expires",
    expired: "Expired",
    daysLeft: "days left",
    
    // User Management
    userManagement: "User Management",
    users: "Users",
    createUser: "Create User",
    editUser: "Edit User",
    displayName: "Display Name",
    role: "Role",
    admin: "Admin",
    active: "Active",
    inactive: "Inactive",
    resetPassword: "Reset Password",
    
    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success",
    warning: "Warning",
    info: "Info",
    yes: "Yes",
    no: "No",
    ok: "OK",
    close: "Close",
    search: "Search",
    filter: "Filter",
    sortBy: "Sort by",
    actions: "Actions",
    view: "View",
    edit: "Edit",
    create: "Create",
    update: "Update",
    gridView: "Grid View",
    years: "years",
    yrs: "yrs",
    meters: "m",
    minutes: "min",
    seconds: "sec",
    
    // Settings
    settings: "Settings",
    globalSettings: "Global Settings",
    globalSettingsDesc: "Configure event timing parameters used in live events.",
    eventParameters: "Event Parameters",
    durationPerPassageMinutes: "Duration per Passage (min)",
    briefingDurationMinutes: "Briefing Duration (min)",
    warmupDurationMinutes: "Warm-up Duration (min)",
    officialZoneDurationMinutes: "Official Zone Duration (min)",
    durationBeforeProtestMinutes: "Time Before Protest (min)",
    protestTimeDurationMinutes: "Protest Time Duration (min)",
    saveSettings: "Save Settings",
    settingsSavedSuccess: "Settings saved successfully",
    saving: "Saving...",
    competitionDetails: "Competition Details",
    poolDetails: "Pool Details",
    depth: "Depth",
    maxCapacity: "Max Capacity",
    capacity: "Capacity",
    lanes: "Lanes",
    trainingModule: "Training Module",
    management: "Management",
    laneMatrix: "Lanes",
    tableView: "Table",
    lane: "Lane",
    selectAquaticInfrastructure: "Select Aquatic Infrastructure (optional)",
    selectInfrastructurePlaceholder: "Choose a pool to auto-fill fields...",
    none: "None",
    language: "Language",
    english: "English",
    french: "French",
    theme: "Theme",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    
    // Disciplines (for dashboard event types)
    disciplinePool: "Pool",
    disciplineDepth: "Depth",
    disciplineEndurance: "Endurance",
    disciplineEvent: "Event",
    staticApnea: "Static Apnea",
    dynamicWithFins: "Dynamic with Fins",
    dynamicNoFins: "Dynamic No Fins",
    dynamicBifins: "Dynamic Bifins",
    constantWeight: "Constant Weight",
    constantWeightNoFins: "Constant Weight No Fins",
    constantWeightBifins: "Constant Weight Bifins",
    freeImmersion: "Free Immersion",
    endurance16x25: "16x25m Endurance",
    endurance16x50: "16x50m Endurance",
    variableWeight: "Variable Weight",
    noLimits: "No Limits",
    
    // Event type detailed descriptions
    descSTA: "Static apnea is the purest discipline of competitive freediving. The athlete remains motionless, typically face down in the water at the surface, and holds their breath for as long as possible. This event takes place in a pool and emphasizes mental management, deep relaxation, and oxygen consumption optimization. It is often the first discipline practiced by beginners as it allows them to develop body awareness and understand their limits without the stress of movement. Current world records exceed 11 minutes for men and 9 minutes for women.",
    descDYN: "Dynamic apnea consists of covering the greatest possible distance in a pool, in a single breath, using a monofin. The athlete moves underwater in a horizontal position, generally between one and two meters depth. This discipline combines respiratory endurance with technical efficiency in fin propulsion. The monofin, inspired by dolphin swimming, optimizes propulsion while minimizing energy expenditure. The world's best freedivers cover more than 300 meters in a single breath, transforming the pool into a true arena for aquatic achievement.",
    descDNF: "Dynamic apnea no fins represents the purest form of freediving propulsion, where the athlete progresses only through arm movements, generally using underwater breaststroke. This discipline requires perfectly mastered swimming technique to minimize water resistance and conserve oxygen. Without the help of fins, every movement must be calculated and fluid. It is a particularly demanding event that reveals the freediver's true aquatic efficiency. World records are around 240 meters for men and 185 meters for women, demonstrating the remarkable achievement this discipline represents.",
    descDYNBF: "Dynamic apnea with bifins follows the same principles as dynamic apnea, but uses two traditional fins instead of a monofin. This variant offers a different technical alternative, with alternating fin kicks that more closely resemble classic swimming. Bifins provide a more accessible propulsion method for beginners while offering excellent performance for experienced athletes. This discipline requires precise coordination and efficient body undulation. World performances with bifins reach approximately 280-290 meters, slightly less than monofin due to different energy efficiency.",
    descCWT: "Constant weight is the premier discipline of depth freediving. The freediver descends and ascends with the same weight (ballast) throughout the dive, using a monofin for propulsion. This event requires exceptional physical condition, perfect finning technique, and flawless mental management. The athlete must optimize their descent with passive free fall after the initial finning phase, then actively ascend while fighting against the negative buoyancy of the depths. Current world records exceed 130 meters for men and 105 meters for women, constantly pushing the boundaries of human physiology.",
    descCNF: "Constant weight no fins is considered the purest and most difficult discipline of deep freediving. The athlete descends and ascends using only the strength of their arms and legs, without any fin assistance, while maintaining the same ballast throughout the dive. This discipline requires exemplary underwater swimming technique, generally using breaststroke, and perfect hydrodynamic management. Every movement must be calculated to conserve oxygen while progressing efficiently. It is the event that most closely resembles ancestral freediving and demands the greatest bodily control. World records are around 102 meters for men and 73 meters for women.",
    descCWTBF: "Constant weight with bifins follows the same principle as classic constant weight, but the freediver uses two traditional fins instead of a monofin. This variant offers an interesting technical alternative, particularly for athletes who prefer alternating fin kicks or who don't have access to a monofin. Bifins also provide better stability during descent and ascent, which can be an advantage for some freedivers. Although less widespread than the monofin version in international competitions, this discipline remains popular in certain countries and delivers remarkable performances, with records approaching 115-120 meters depth.",
    descFIM: "Free immersion is a depth discipline where the freediver descends and ascends along a vertical line by pulling themselves with their arms only, without using fins or any propulsion system. This technique, similar to traditional fishermen's freediving, offers a controlled and energy-efficient descent. The athlete can fully focus on ear equalization and buoyancy management. The constant contact with the line also provides a reassuring reference point and allows precise speed control. World records exceed 125 meters depth, making this discipline an excellent training ground for learning to manage pressure and depth.",
    desc16x25: "An endurance event where athletes complete 16 consecutive 25-meter underwater swims with short recovery intervals. Tests both aerobic capacity and breath-hold ability.",
    desc16x50: "An endurance event where athletes complete 16 consecutive 50-meter underwater swims with short recovery intervals. A demanding test of endurance and mental fortitude.",
    
    // User Management
    userManagementTitle: "User Access Management",
    createNewUser: "Create New User",
    editUserTitle: "Edit User",
    userCreatedSuccess: "User created successfully",
    userUpdatedSuccess: "User updated successfully",
    userDeletedSuccess: "User deleted successfully",
    confirmDeleteUser: "Are you sure you want to delete this user?",
    preferredLanguage: "Preferred Language",
    accountStatus: "Account Status",
    lastLogin: "Last Login",
    neverLoggedIn: "Never logged in",
    manageUserAccounts: "Manage user accounts and permissions.",
    newPassword: "New Password (leave blank to keep current)",
    readOnly: "Read-only",
    standard: "Standard",
    fullAccess: "Full Access",
    
    // Calendar View
    selectDate: "Select Date",
    hasSession: "Has Session",
    selected: "Selected",
    sessionsFor: "Sessions for",
    selectDateToViewSessions: "Select a date to view sessions",
    noSessionsOnDate: "No training sessions on this date",
    clickDateToView: "Click on a date to view or create training sessions",
    
    // Scoring rules
    scoringPointsPer5Seconds: "1 point per 5 seconds",
    scoringPointsPerMeter: "0.5 point per meter",
    
    // Freedivers Filters
    filterByNationality: "Filter by Nationality",
    filterByGenderFreedivers: "Filter by Gender",
    allNationalities: "All Nationalities",
    allGenders: "All Genders",
    viewPerformances: "View Performances",
    searchFreedivers: "Search freedivers...",
    
    // Medical Certificate
    medicalCertificate: "Medical Certificate",
    certificateStatus: "Certificate Status",
    certificateValid: "Valid",
    certificateInvalid: "Invalid / Expired",
    certificateNotUploaded: "Not Uploaded",
    uploadCertificate: "Upload Certificate",
    replaceCertificate: "Replace Certificate",
    previewCertificate: "Preview Certificate",
    downloadCertificate: "Download Certificate",
    removeCertificate: "Remove Certificate",
    certificateUploadDate: "Upload Date",
    medicalCertificateManagement: "Medical Certificate Management",
    markAsValid: "Mark as Valid",
    markAsInvalid: "Mark as Invalid",
    pdfFilesOnly: "PDF files only (max 5MB)",
    
    // CSV Import
    importCSV: "Import CSV",
    downloadTemplate: "Download Template",
    importFreedivers: "Import Freedivers",
    csvImportResults: "Import Results",
    totalProcessed: "Total Processed",
    totalCreated: "Successfully Created",
    totalErrors: "Errors",
    importSuccess: "Import completed successfully",
    importError: "Error importing freedivers",
    row: "Row",
    selectCSVFile: "Select a CSV file to import",
    csvFileSelected: "File selected",
    
    // Certificate Dates
    certificateStartDate: "Start Date",
    certificateExpiryDate: "Expiry Date",
    certificateUploaded: "Certificate Uploaded",
    previewPDF: "Preview PDF",
    
    // Freediving Levels
    freedivingLevels: "Freediving Levels",
    freedivingLevelsDescription: "Certification levels by agency for freediving organizations worldwide",
    agencies: "Agencies",
    levels: "levels",
    beginnerLevels: "Beginner Levels",
    intermediateLevels: "Intermediate Levels",
    advancedLevels: "Advanced Levels",
    expertLevels: "Expert Levels",
    instructorLevels: "Instructor Levels",
    otherLevels: "Other Levels",
    selectCertificationLevel: "Select certification level",
    noCertificationAgency: "Please select a certification agency first",
    
    // Dashboard Calendar & Certificates
    weeklyCalendar: "Weekly Training Calendar",
    today: "Today",
    noSessions: "No sessions",
    totalSessions: "total sessions",
    thisWeek: "this week",
    noTrainingSessionsYet: "No training sessions scheduled yet",
    more: "more",
    expiringCertificatesDesc60: "The following freedivers have medical certificates expiring within 60 days or already expired:",
    days: "days",
    
    // Exercise Import & Attendance
    importExercises: "Import Exercises",
    importSessions: "Import Sessions",
    downloadTemplateFirst: "Download the template file, fill it with your exercises, then upload it here.",
    selectExcelFile: "Select Excel or CSV file",
    importResults: "Import Results",
    processed: "Processed",
    created: "Created",
    errors: "Errors",
    attendance: "Attendance",
    present: "Present",
    absent: "Absent",
    excused: "Excused",
    late: "Late",
    pending: "Pending",
    noParticipants: "No participants assigned",
    upcomingSessions: "Upcoming Sessions",
    sessionReminder: "Session Reminder",
    tomorrow: "Tomorrow",
    // Capacity alerts
    capacityAlerts: "Capacity Alerts",
    full: "Full",
    nearFull: "Near Full",
    filling: "Filling",
    available: "Available",
    capacityAlertNote: "Sessions at 80%+ capacity are shown above",
    // Exercise Library
    distanceDuration: "Dist./Dur.",
    importExercises: "Import Exercises",
    importSessions: "Import Sessions",
    step: "Step",
    clickToSelectFile: "Click to select file",
    importing: "Importing...",
    // Address fields
    addressInformation: "Address Information",
    phoneNumber: "Phone Number",
    addressNumber: "Number",
    addressType: "Type",
    addressName: "Street Name",
    city: "City",
    stateProvince: "State/Province",
    postalCode: "Postal Code",
    addressCountry: "Country",
    selectType: "Select type",
    // Delete confirmation
    confirmDelete: "Confirm Deletion",
    confirmDeleteFreediverMessage: "Are you sure you want to delete this freediver? This action cannot be undone.",
    deleting: "Deleting...",
    delete: "Delete",
    errorDeletingFreediver: "Error deleting freediver. Please try again.",
    cannotDeleteWithRegistrations: "Cannot delete freediver with existing event registrations. Please unregister from all events first.",
    // Registration
    confirmUnregister: "Confirm Unregistration",
    confirmUnregisterMessage: "Are you sure you want to unregister this freediver from the event?",
    unregister: "Unregister",
    errorUnregistering: "Error unregistering. Please try again.",
    noRegistrationsYet: "No Registrations Yet",
    startByRegistering: "Start by registering freedivers for events in competitions.",
    // Calendar
    sessionsFor: "Sessions for",
    noSessions: "No sessions",
    // Live Event Management
    clearOrphanSessions: "Clear Orphan Sessions",
    forceStartNow: "Force Start Now",
    activeEventBanner: "Active Event",
    goToLiveEvent: "Go to Live Event",
    // Penalty Calculator
    penaltyCalculator: "Penalty Calculator",
    announcedPerformance: "Announced Performance (AP)",
    realizedPerformance: "Realized Performance (RP)",
    addPenalties: "Add Penalties",
    activePenalties: "Active Penalties",
    surfaceProtocol: "Surface Protocol",
    timeLimit: "Time Limit",
    savePerformance: "Save Performance",
    // Dashboard Live Event
    liveEventActive: "Live Event in Progress",
    viewLiveEvent: "View Live Event",
    spectatorView: "Spectator View",
    spectator: "Spectator",
    elapsed: "Elapsed",
    // Simulation Mode
    eventLiveSimulation: "Event Live Simulation",
    eventLiveSimulationDesc: "Enable simulation mode to test live events with skip-to-next functionality",
    simulationModeActive: "Simulation Mode Active",
    simulationModeHint: "Use \"Skip to Official Countdown\" to fast-forward through passages",
    skipToNextCountdown: "Skip to Next",
    resetActiveSession: "Reset Active Session",

    // Organizations & Memberships
    organizations: "Organization(s)",
    organizationsList: "Organizations",
    addOrganization: "Add Organization",
    editOrganization: "Edit Organization",
    organizationName: "Organization Name",
    organizationType: "Type",
    membershipType: "Membership Type",
    addressNumber: "Number",
    street: "Street",
    city: "City",
    province: "Province",
    country: "Country",
    postalCode: "Postal Code",
    validityPeriodStart: "Validity Start",
    validityPeriodEnd: "Validity End",
    validityYears: "Year(s) of Validity",
    validity: "Validity",
    website: "Website",
    phone: "Phone",
    noOrganizations: "No organizations yet",
    addOrganizationHint: "Click \"Add Organization\" to get started",
    addMember: "Add Member",
    addMemberTo: "Add Member to",
    searchFreediver: "Search Freediver",
    selected: "Selected",
    noMembers: "No members registered yet",
    noResults: "No results",
    valid: "Valid",
    expired: "Expired",
    expiringSoon: "Expiring Soon",
    active: "Active",
    missing: "Missing",
    medicalCertificate: "Med. Cert.",
    period: "Period",
    create: "Create",
    update: "Update",
    sex: "Sex",
    nationality: "Nat.",

    // RBAC Module Groups
    moduleGroupCompetitions: "Competitions",
    moduleGroupFreedivers: "Freedivers",
    moduleGroupTraining: "Training",
    moduleGroupManagement: "Management",
    moduleGroupReference: "Reference",
    moduleCompetitions: "Competitions",
    moduleRegistrations: "Registrations",
    moduleLiveEvents: "Live Events",
    moduleEventResults: "Event Results",
    moduleFreedivers: "Freedivers",
    moduleFollowUp: "Follow-up",
    modulePerformanceComparison: "Performance Comparison",
    moduleTrainingSessions: "Training Sessions",
    moduleExerciseLibrary: "Exercise Library",
    moduleSessionBuilder: "Session Builder",
    moduleApneaTables: "Apnea Tables",
    moduleOrganizations: "Organizations",
    moduleAquaticInfrastructure: "Aquatic Infrastructure",
    allowedModules: "Allowed Modules",
    assignedOrganizations: "Assigned Organizations",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    allOrganizations: "All organizations (admin)",
    noOrganizationAssigned: "No organization assigned",
    selectOrganizations: "Select organizations...",
    accessAllModules: "Admin: full access to all modules",
    accessAllOrgs: "Admin: access to all organizations",
    page: "Page",
    of: "of",
    permissions: "Permissions",
    copyRightsFrom: "Copy rights from:",
    selectUser: "Select a user...",
    pdfImportDescription: "Upload a PDF training plan. The AI will analyze the document and automatically create the training session with all exercises.",
    selectPdfFile: "Select a PDF training plan",
    aiAnalyzing: "AI is analyzing the document...",
    analyzePdf: "Analyze PDF",
    importSuccess: "Import Successful"
  },
  
  fr: {
    // App Header
    appTitle: "Apnea Coach Manager",
    appSubtitle: "Gestionnaire d'entraînement et de compétition de plongée libre par https://apneeaquarius.ca/",
    
    // Authentication
    connect: "Connexion",
    disconnect: "Déconnexion",
    signIn: "Se connecter",
    signInTitle: "Connexion à Apnea Coach Manager",
    signInDescription: "Entrez vos identifiants pour accéder à toutes les fonctionnalités.",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    enterUsername: "Entrez votre nom d'utilisateur",
    enterPassword: "Entrez votre mot de passe",
    cancel: "Annuler",
    invalidCredentials: "Nom d'utilisateur ou mot de passe invalide",
    administrator: "Administrateur",
    user: "Utilisateur",
    viewer: "Observateur",
    
    // Navigation
    dashboard: "Tableau de bord",
    contests: "Événement(s)",
    competitions: "Compétitions",
    registrations: "Inscriptions",
    liveEvents: "Événements en direct",
    eventResults: "Résultats",
    career: "Carrière",
    freedivers: "Apnéistes",
    followUp: "Suivi",
    performanceComparison: "Comparaison des performances",
    trainingSessions: "Séances d'entraînement",
    aquaticInfrastructure: "Infrastructure aquatique",
    
    // Dashboard
    dashboardTitle: "Que l'Apnée soit avec vous!",
    dashboardSubtitle: "Votre plateforme complète de gestion des activités d'apnée sportive",
    totalCompetitions: "Total des compétitions",
    registeredFreedivers: "Apnéistes inscrits",
    eventRegistrations: "Inscriptions aux événements",
    activeCompetitions: "Compétitions actives",
    welcomeTitle: "Bienvenue sur Apnea Coach Manager",
    welcomeDescription: "Votre plateforme complète pour gérer les compétitions de plongée libre, suivre les performances des athlètes et créer des programmes d'entraînement.",
    competitionManagement: "Gestion des compétitions",
    competitionManagementDesc: "Créez et gérez des compétitions avec plusieurs types d'épreuves, notation en temps réel et surveillance des événements en direct.",
    athleteTracking: "Suivi des athlètes",
    athleteTrackingDesc: "Inscrivez les apnéistes, suivez leurs certifications et surveillez leur historique de performances.",
    performanceFollowUp: "Suivi des performances",
    performanceFollowUpDesc: "Enregistrez les performances d'entraînement avec des métriques détaillées, validation par l'entraîneur et classement automatique.",
    trainingSessionsDesc: "Créez des programmes d'entraînement personnalisés avec des exercices, des modèles et des outils de planification.",
    liveEventsDesc: "Interface de juge en temps réel avec chronomètres, saisie RP et calcul automatique des résultats.",
    supportedEvents: "Épreuves supportées",
    
    // Freedivers
    freediversTitle: "Apnéistes",
    registerFreediver: "Inscrire un apnéiste",
    addFreediver: "Ajouter un apnéiste",
    addFreediverDescription: "Saisissez les informations du nouvel apnéiste ci-dessous.",
    editFreediver: "Modifier l'apnéiste",
    updateFreediverDetails: "Modifier les informations de l'apnéiste ci-dessous.",
    validFrom: "Valide du",
    validUntil: "Valide jusqu'au",
    valid: "Valide",
    expired: "Expiré",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Courriel",
    nationality: "Nationalité",
    gender: "Genre",
    male: "Masculin",
    female: "Féminin",
    dateOfBirth: "Date de naissance",
    placeOfBirth: "Lieu de naissance",
    certificationAgency: "Organisme de certification",
    certificationLevel: "Niveau de certification",
    experienceLevel: "Niveau d'expérience",
    beginner: "Débutant",
    intermediate: "Intermédiaire",
    advanced: "Avancé",
    elite: "Élite",
    coachTrainer: "Moniteur/Entraineur",
    markAsCoach: "Moniteur/Entraineur",
    photo: "Photo",
    uploadPhoto: "Télécharger une photo",
    changePhoto: "Changer la photo",
    removePhoto: "Supprimer la photo",
    save: "Enregistrer",
    delete: "Supprimer",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ceci?",
    
    // Follow Up
    followUpTitle: "Suivi - Tracking des apnéistes",
    selectFreediverToTrack: "Sélectionner un apnéiste à suivre",
    searchFreediver: "Rechercher un apnéiste...",
    addPerformance: "Ajouter une performance",
    editPerformance: "Modifier la performance",
    performanceSummaryByType: "Résumé des performances par type",
    performanceHistory: "Historique des performances",
    noPerformancesYet: "Aucune performance enregistrée. Cliquez sur \"Ajouter une performance\" pour commencer le suivi.",
    performanceDate: "Date de la performance",
    performanceType: "Type de performance",
    location: "Lieu",
    poolType: "Type de piscine",
    distance: "Distance",
    distanceMeters: "Distance (mètres)",
    durationMinutes: "Durée (Minutes)",
    durationSeconds: "Durée (Secondes)",
    duration: "Durée",
    reps: "Rép.",
    prebuilt: "Prédéfini",
    type: "Type",
    actions: "Actions",
    coachTrainerSelect: "Entraîneur/Formateur",
    noCoachSelected: "Aucun entraîneur sélectionné",
    noCoachesAvailable: "Aucun entraîneur disponible. Marquez un apnéiste comme \"Entraîneur/Formateur\" dans la section Apnéistes.",
    comments: "Commentaires/Observations",
    preparationProtocol: "Protocole de préparation",
    yrsShort: "ans",
    yearsOld: "ans",
    perfSummaryByType: "Résumé des performances par type",
    gold: "Or",
    silver: "Argent",
    bronze: "Bronze",
    addNewPerformance: "Ajouter une nouvelle performance",
    updatePerfDetails: "Mettre à jour les détails de la performance.",
    recordNewPerf: "Enregistrer une nouvelle performance pour le suivi.",
    locationPlaceholder: "ex. Centre Aquatique de Paris",
    distancePlaceholder: "ex. 150",
    coachTrainer: "Entraîneur/Formateur",
    selectCoach: "Sélectionner un entraîneur",
    commentsObservations: "Commentaires/Observations",
    notesPlaceholder: "Notes sur la performance...",
    protocolPlaceholder: "Protocole de préparation détaillé...",
    updatePerformance: "Mettre à jour la performance",
    
    // Performance Comparison
    compareFreedivers: "Comparer les apnéistes",
    progressTrend: "Tendance de progression",
    selectFreediversMax4: "Sélectionner les apnéistes (max 4)",
    selectFreediver: "Sélectionner un apnéiste",
    chooseFreediver: "Choisir un apnéiste...",
    fromDate: "Date de début",
    toDate: "Date de fin",
    selectFreediversToCompare: "Sélectionner les apnéistes à comparer",
    selectUpTo4Freedivers: "Sélectionnez jusqu'à 4 apnéistes pour comparer leurs performances côte à côte.",
    selectFreediverForTrend: "Sélectionner un apnéiste",
    selectFreediverToAnalyze: "Sélectionnez un apnéiste pour analyser ses tendances de performance.",
    progressOverTime: "Progression dans le temps",
    bestPerformances: "Meilleures performances",
    noDataForSelectedFilters: "Aucune donnée disponible pour les filtres sélectionnés.",
    best: "Meilleur",
    average: "Moyenne",
    totalPerformances: "Performances",
    firstRecord: "Premier record",
    latestRecord: "Dernier record",
    personalBest: "Record personnel",
    improvement: "Amélioration",
    change: "Changement",
    performanceTrend: "Tendance de performance",
    date: "Date",
    value: "Valeur",
    
    // Session Builder
    sessionBuilder: "Constructeur de séance",
    sessionTimeline: "Chronologie de la séance",
    addBlock: "Ajouter un bloc",
    blocks: "blocs",
    noBlocksYet: "Aucun bloc pour l'instant",
    addBlocksHint: "Cliquez sur les boutons ci-dessus pour ajouter des blocs d'entraînement, ou ajoutez des exercices de la bibliothèque",
    clearAll: "Tout effacer",
    saveSession: "Enregistrer la séance",
    enterSessionName: "Entrez le nom de la séance...",
    sessionSaved: "Séance enregistrée avec succès!",
    errorSavingSession: "Erreur lors de l'enregistrement. Veuillez réessayer.",
    confirmClearAll: "Êtes-vous sûr de vouloir effacer tous les blocs?",
    sessionNameRequired: "Le nom de la séance est requis",
    addBlocksFirst: "Veuillez ajouter au moins un bloc",
    filterByType: "Filtrer par type",
    noExercisesFound: "Aucun exercice trouvé",
    sessionNotesPlaceholder: "Ajoutez des notes pour cette séance d'entraînement...",
    
    // PDF/Excel Parsing
    uploadTrainingPdf: "Télécharger un PDF d'entraînement",
    parsePdf: "Analyser le PDF",
    parsingPdf: "Analyse du PDF...",
    pdfParsed: "PDF analysé avec succès",
    pdfParseError: "Erreur lors de l'analyse du PDF",
    exercisesFound: "exercices trouvés",
    blocksDetected: "blocs détectés",
    importExercises: "Importer les exercices",
    importSessions: "Importer des séances",
    importAllBlocks: "Importer tous les blocs",
    previewParsedContent: "Aperçu du contenu analysé",
    rawTextPreview: "Aperçu du texte brut",
    noExercisesExtracted: "Aucun exercice n'a pu être extrait de ce fichier",
    selectPdfFile: "Sélectionner un fichier PDF",
    dropPdfHere: "Déposez le PDF ici ou cliquez pour parcourir",
    pdfFilesOnlyMax10: "Fichiers PDF uniquement (max 10Mo)",
    parsedExercises: "Exercices analysés",
    parsedBlocks: "Blocs analysés",
    addParsedToSession: "Ajouter à la séance",
    importPdfExercises: "Importer depuis PDF",
    closePreview: "Fermer l'aperçu",
    totalExercises: "Total des exercices",
    // Excel parsing
    importFromFile: "Importer depuis fichier",
    parsingFile: "Analyse du fichier...",
    fileParsed: "Fichier analysé avec succès",
    fileParseError: "Erreur lors de l'analyse du fichier",
    pdfOrExcelOnly: "PDF ou Excel uniquement (max 10Mo)",
    excelParsed: "Excel analysé avec succès",
    
    // Aquatic Infrastructure
    aquaticInfrastructureTitle: "Infrastructure aquatique",
    addPoolLocation: "Ajouter un lieu de piscine",
    editPoolLocation: "Modifier le lieu de piscine",
    noPoolLocationsYet: "Aucun lieu de piscine",
    addFirstPoolLocation: "Ajoutez votre première infrastructure aquatique pour commencer à gérer les lieux de piscine.",
    shortName: "Nom court",
    longName: "Nom complet",
    organization: "Organisation",
    buildingName: "Nom du bâtiment",
    poolSpecifications: "Spécifications de la piscine",
    poolLength: "Longueur de la piscine (m)",
    numberOfLanes: "Nombre de couloirs",
    minDepth: "Profondeur min (m)",
    maxDepth: "Profondeur max (m)",
    maxCapacity: "Capacité maximale",
    address: "Adresse",
    streetNumber: "Numéro",
    street: "Rue",
    streetType: "Type",
    city: "Ville",
    postalCode: "Code postal",
    province: "Province/État",
    country: "Pays",
    logo: "Logo",
    uploadLogo: "Télécharger un logo",
    changeLogo: "Changer le logo",
    websiteUrl: "URL du site web",
    visitWebsite: "Visiter le site web",
    
    // Training Sessions
    trainingSessionsTitle: "Séances d'entraînement",
    newTrainingSession: "Nouvelle séance",
    editTrainingSession: "Modifier la séance",
    createNewTrainingSession: "Créer une nouvelle séance d'entraînement",
    sessionName: "Nom de la séance",
    discipline: "Discipline",
    coachInstructorName: "Entraîneur/Instructeur",
    selectCoach: "Sélectionner un entraîneur...",
    trainingTemplate: "Modèle d'entraînement (Optionnel)",
    choosePrebuiltTemplates: "Choisir parmi les modèles pré-définis",
    selectTemplateOrCustom: "Sélectionnez un modèle ou créez une séance personnalisée",
    createCustomSession: "Créer une séance personnalisée",
    trainingLocation: "Lieu d'entraînement",
    quickFillFromSavedPools: "Remplissage rapide depuis les piscines enregistrées",
    enterManually: "Entrer manuellement",
    selectPoolOrEnterManually: "Sélectionnez un lieu de piscine enregistré pour remplir automatiquement les détails ci-dessous, ou choisissez \"Entrer manuellement\" pour saisir des valeurs personnalisées.",
    buildingFacilityName: "Nom du bâtiment/installation",
    hostOrganization: "Organisation hôte",
    streetAddress: "Adresse",
    trainingBlocks: "Blocs d'entraînement",
    totalDistance: "Distance totale",
    listView: "Vue liste",
    calendarView: "Vue calendrier",
    // Document Attachments
    documentAttachments: "Pièces jointes",
    addAttachment: "Ajouter une pièce jointe",
    attachFiles: "Joindre des fichiers",
    allowedFileTypes: "Autorisés: Excel (.xlsx, .xls), Word (.docx, .doc), PDF",
    invalidFileType: "Type de fichier invalide",
    fileTooLarge: "Fichier trop volumineux",
    noAttachments: "Aucune pièce jointe",
    removeAttachment: "Supprimer",
    downloadAttachment: "Télécharger",
    attachedFiles: "Fichiers joints",
    
    // Template Management
    manageTemplates: "Modèles",
    createTemplate: "Créer un modèle personnalisé",
    editTemplate: "Modifier le modèle",
    newTemplate: "Nouveau modèle",
    saveTemplate: "Enregistrer le modèle",
    updateTemplate: "Mettre à jour le modèle",
    yourTemplates: "Vos modèles personnalisés",
    templateName: "Nom du modèle",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ceci ?",
    
    // Participant Management
    participants: "Participants",
    manageParticipants: "Gérer les participants",
    currentParticipants: "Participants actuels",
    addParticipant: "Ajouter un participant",
    noParticipants: "Aucun participant assigné",
    noParticipantsSelected: "Aucun participant sélectionné",
    allFreediversAssigned: "Tous les apnéistes sont déjà assignés",
    
    // Inline Editing
    quickEdit: "Modification rapide",
    doubleClickToEdit: "Double-cliquez pour modifier rapidement",
    
    // Competitions
    competitionsTitle: "Compétitions",
    newCompetition: "Nouvelle compétition",
    editCompetition: "Modifier la compétition",
    createNewCompetition: "Créer une nouvelle compétition",
    competitionName: "Nom de la compétition",
    startDate: "Date de début",
    endDate: "Date de fin",
    lanes: "Couloirs",
    federation: "Fédération",
    maxFreedivers: "Nombre max d'apnéistes",
    organizer: "Organisateur",
    contactName: "Nom du contact",
    contactEmail: "Courriel du contact",
    contactPhone: "Téléphone du contact",
    contactAddress: "Adresse du contact",
    description: "Description",
    competitionLogo: "Logo de la compétition",
    selectLogo: "Sélectionner un logo",
    updateCompetition: "Mettre à jour la compétition",
    deleteCompetition: "Supprimer la compétition",
    competitionDetails: "Détails de la compétition",
    registrationsClosed: "Inscriptions fermées",
    registrationsOpen: "Inscriptions ouvertes",
    
    // Registrations
    registrationsTitle: "Inscriptions aux épreuves",
    eventRegistrations: "Inscriptions aux événements",
    bulkRegistration: "Inscriptions multiples",
    bulkRegistrationDesc: "Sélectionnez une compétition et une épreuve, puis glissez-déposez les apnéistes ou utilisez le bouton +.",
    singleRegistration: "Inscription rapide",
    inscritList: "Inscrits",
    availableFreedivers: "Apnéistes disponibles",
    searchByName: "Recherche par nom ou prénom...",
    newRegistration: "Nouvelle inscription",
    createRegistration: "Créer l'inscription",
    createRegistrationDesc: "Inscrire un apnéiste à une épreuve d'une compétition.",
    selectCompetition: "Sélectionner une compétition",
    selectFreediver: "Sélectionner un apnéiste",
    selectEventType: "Sélectionner le type d'épreuve",
    selectEvents: "Sélectionner les épreuves",
    announcedPerformance: "Performance annoncée",
    registered: "inscrits",
    startLiveEvent: "Démarrer événement en direct",
    showList: "Afficher la liste",
    hideList: "Masquer la liste",
    unregister: "Désinscrire",
    noRegistrationsYet: "Aucune inscription pour le moment",
    startByRegistering: "Commencez par inscrire des apnéistes aux épreuves des compétitions.",
    confirmUnregister: "Confirmer la désinscription",
    confirmUnregisterMessage: "Êtes-vous sûr de vouloir désinscrire cet apnéiste de l'épreuve ?",
    errorUnregistering: "Erreur lors de la désinscription. Veuillez réessayer.",
    eventLabel: "Épreuve",
    competition: "Compétition",
    freediver: "Apnéiste",
    eventType: "Type d'épreuve",
    editEventRegistration: "Modifier l'inscription",
    officialTop: "Top officiel",
    countdownToOfficialTop: "Compte à rebours Top Officiel",
    warmUpTime: "Heure d'échauffement",
    registrationStatus: "Statut",
    pending: "En attente",
    confirmed: "Confirmé",
    withdrawn: "Retiré",
    disqualified: "Disqualifié",
    
    // Training Sessions Form
    trainingDate: "Date d'entraînement",
    startTime: "Heure de début",
    endTime: "Heure de fin",
    additionalNotes: "Notes supplémentaires",
    saveAsTemplate: "Enregistrer comme modèle",
    templateName: "Nom du modèle",
    createSession: "Créer la séance",
    updateSession: "Mettre à jour la séance",
    cancelSession: "Annuler",
    cloneSession: "Dupliquer",
    deleteSession: "Supprimer",
    trainingProgram: "Programme d'entraînement",
    noExerciseBlocks: "Aucun bloc d'exercice défini. Ajoutez des blocs ci-dessus ou sélectionnez un modèle.",
    details: "Détails",
    poolInfo: "Info piscine",
    lanes: "couloirs",
    depth: "Profondeur",
    minutes: "minutes",
    
    // Exercise Blocks
    exerciseBlocks: "Blocs d'exercices",
    addBlock: "Ajouter un bloc",
    blockName: "Nom du bloc",
    blockDuration: "Durée (minutes)",
    blockNotes: "Notes du bloc",
    exercises: "Exercices",
    addExercise: "Ajouter un exercice",
    exerciseName: "Nom de l'exercice",
    exerciseType: "Type d'exercice",
    exerciseDescription: "Description de l'exercice",
    exerciseInstructions: "Instructions",
    repetitions: "Répétitions",
    restSeconds: "Repos (secondes)",
    noExercisesInBlock: "Aucun exercice dans ce bloc",
    
    // Custom Exercise Library
    exerciseLibrary: "Bibliothèque d'exercices",
    customExercises: "Exercices personnalisés",
    createCustomExercise: "Créer un exercice personnalisé",
    editCustomExercise: "Modifier l'exercice",
    myExercises: "Mes exercices",
    publicExercises: "Exercices publics",
    prebuiltExercises: "Exercices prédéfinis",
    exerciseCategory: "Catégorie",
    targetDiscipline: "Discipline cible",
    difficultyLevel: "Niveau de difficulté",
    makePublic: "Rendre public",
    publicExerciseHint: "Les exercices publics sont visibles par tous les utilisateurs",
    noCustomExercises: "Aucun exercice personnalisé. Créez votre premier!",
    addToSession: "Ajouter à la séance",
    duplicateExercise: "Dupliquer",
    exerciseDetails: "Détails de l'exercice",
    selectFromLibrary: "Sélectionner dans la bibliothèque",
    searchExercises: "Rechercher des exercices...",
    warmUp: "Échauffement",
    breathHold: "Apnée",
    dynamic: "Dynamique",
    static: "Statique",
    recovery: "Récupération",
    coolDown: "Retour au calme",
    technique: "Technique",
    
    // Live Events
    liveEventsTitle: "Événements en direct",
    cancelEvent: "Annuler événement",
    confirm: "Confirmer",
    liveEventManagement: "Gestion des événements en direct",
    startSession: "Démarrer la session",
    eventSessions: "Sessions d'événement",
    noEventSessions: "Aucune session d'événement trouvée",
    importExcelToCreate: "Importez un fichier Excel pour créer des sessions d'événement",
    refreshSessions: "Actualiser les sessions",
    globalEventTimer: "Chronomètre global de l'événement",
    disciplineEvent: "Épreuve de discipline",
    resetToZero: "Remettre à zéro",
    confirmResetTimer: "Remettre le chronometre de l'epreuve a zero? Cela ne reinitialise que l'affichage, pas les donnees.",
    restartEvent: "Redémarrer l'événement",
    confirmRestartEvent: "Redémarrer l'événement? Toutes les performances seront effacées et les compteurs repartiront de maintenant.",
    stopEvent: "Mettre en pause",
    pauseEvent: "Mettre en pause",
    resumeEvent: "Reprendre l'événement",
    finishEvent: "Terminer l'événement",
    quickEntry: "Saisie rapide — Apnéistes restants",
    quickEntryDesc: "Saisissez les résultats des apnéistes restants. Le score est calculé automatiquement selon les règles de l'agence (AIDA/CMAS).",
    confirmFinishEvent: "Terminer l'événement ? Toutes les performances seront enregistrées dans le suivi/carrière. Continuer ?",
    eventFinished: "Événement terminé. Performances enregistrées dans le suivi de carrière.",
    fullName: "Nom complet",
    transit: "Transit",
    official: "Officiel",
    eventStarted: "Événement démarré",
    paused: "EN PAUSE",
    addPenalty: "Ajouter",
    avgSpeed: "Vitesse moy.",
    configureZones: "Configurer les zones",
    configureZonesDesc: "Configurez les couloirs de performance et l'attribution des zones pour cette compétition.",
    numberOfZones: "Nombre de zones",
    zone: "Zone",
    zone1Desc: "Séquentiel — un apnéiste à la fois",
    zone2Desc: "Parallèle — deux apnéistes démarrent au même OT",
    poolDiagram: "Schéma du bassin",
    lanes: "couloirs",
    lane: "Couloir",
    unassigned: "non assigné",
    performanceLane: "Couloir performance",
    warmupLane: "Couloir échauffement",
    transitLane: "Couloir transit",
    assignedUsers: "Opérateurs assignés",
    noUsersToAssign: "Aucun utilisateur à assigner — créez des comptes d'abord.",
    saveConfiguration: "Enregistrer la configuration",
    rolePalette: "Palette de rôles",
    dragToLane: "(glissez vers un couloir)",
    dropRoleHere: "déposez un rôle ici",
    clearLane: "Vider ce couloir",
    resetAll: "Tout réinitialiser",
    perfLaneRequired: "Chaque zone doit avoir un couloir de performance.",
    perfLaneConflict: "Le couloir performance doit être unique par zone. Déplacez le rôle en conflit ailleurs.",
    dragDropInstructions: "Glissez les badges de rôle ci-dessous dans les couloirs du bassin. Le couloir performance doit être unique ; échauffement et transit peuvent être partagés.",
    sessionPreview: "Aperçu de la session",
    sessionPreviewDesc: "— visualisez l'ordre de passage qui sera généré",
    runPreview: "Lancer l'aperçu",
    selectEventToPreview: "Sélectionnez un type d'événement à prévisualiser.",
    noRegistrations: "Aucune inscription",
    athletes: "Apnéistes",
    otSlots: "Créneaux OT",
    simultaneousStarts: "Simultanés",
    totalDuration: "Durée totale",
    previewNote: "Aperçu uniquement — l'ordre de passage sera généré à la création d'une session.",
    createSessionFromPreview: "Satisfait de l'aperçu ? Créez la session directement :",
    createSession: "Créer la session",
    newLiveSession: "Nouvelle session live",
    sessionName: "Nom de la session",
    date: "Date",
    time: "Heure",
    intervalDuration: "Intervalle par passage",
    preparationDuration: "Préparation/échauffement",
    createSessionNote: "L'enregistrement persistera la configuration des zones et créera immédiatement la session live.",
    createNow: "Créer maintenant",
    sessionNameRequired: "Le nom de la session est requis.",
    sessionDateTimeRequired: "La date et l'heure de début sont requises.",
    sessionCreatedOK: "Session créée avec succès.",
    sessionCreateFailed: "Échec de la création : ",
    duplicate: "Dupliquer",
    copyShort: "copie",
    duplicateCompetitionPrompt: "Nom de la nouvelle compétition :",
    competitionDuplicated: "Compétition dupliquée",
    duplicateFailed: "Échec de la duplication",
    performance: "PERF",
    transit: "TRANSIT",
    zoneControl: "Contrôle des zones",
    zones: "zones",
    viewingZone: "En vue",
    preferredZone: "ASSIGNÉ",
    you: "VOUS",
    zoneFree: "Libre — n'importe qui peut prendre le contrôle",
    releaseControl: "Libérer",
    takeControl: "Prendre le contrôle",
    forceTakeOverPrompt: "Forcer la reprise ?",
    showAll: "Tout voir",
    view: "Voir",
    finishAndSave: "Terminer & Enregistrer",
    confirmFinishShort: "Oui, terminer l'événement",
    allAthletesCompleted: "Tous les apnéistes ont terminé leur performance.",
    clickFinishToValidate: "Cliquez sur « Terminer & Enregistrer » pour clôturer l'événement et sauvegarder toutes les performances dans le suivi de carrière.",
    athletesRemaining: "restants",
    quickEntered: "saisis rapidement",
    toBeEntered: "non saisis",
    willSaveCareerNote: "Toutes les performances complétées seront enregistrées automatiquement dans le suivi de carrière des apnéistes.",
    errorFinishingEvent: "Échec de la clôture :",
    back: "Retour",
    briefingDuration: "Durée du briefing",
    warmupDuration: "Durée de l'échauffement",
    passageDuration: "Durée du passage",
    liveEvent: "Événement en direct",
    timeToNextContestant: "Temps avant le prochain concurrent",
    currentContestant: "Concurrent actuel",
    totalPassages: "Passages totaux",
    remaining: "Restants",
    currentLane: "Couloir actuel",
    runningOrder: "Ordre de passage",
    contestantOrderForEvent: "Ordre des concurrents pour cet événement",
    noRunningOrderAvailable: "Aucun ordre de passage disponible",
    printPDF: "Imprimer PDF",
    warmup: "Échauffement",
    sex: "Sexe",
    contestant: "Concurrent",
    announced: "Annoncé",
    yellowCard: "Jaune",
    redCard: "Rouge",
    startSession: "Démarrer la session",
    stopSession: "Arrêter la session",
    pauseCountdown: "Pause du compte à rebours",
    resumeCountdown: "Reprendre le compte à rebours",
    startPerformance: "Démarrer la performance",
    endPerformance: "Fin de performance",
    performanceDuration: "Durée",
    stopPerformance: "Arrêter la performance",
    saveResult: "Enregistrer le résultat",
    nextFreediver: "Apnéiste suivant",
    currentFreediver: "Apnéiste actuel",
    nextUp: "Prochain",
    nextContestant: "Prochain concurrent",
    skipToResults: "Passer aux résultats",
    skipToOfficialCountdown: "Passer au compte à rebours officiel",
    waitingForOT: "Attente de l'OT",
    performanceInProgress: "EN COURS",
    validationByJudges: "Performance en validation par les Juges",
    performanceSaved: "Performance enregistree",
    enterResults: "SAISIE RÉSULTATS",
    enterResultsBelow: "Saisir les résultats ci-dessous",
    allPassagesCompleted: "Tous les passages terminés!",
    performanceResults: "Résultats de performance",
    durationOfEvent: "Durée de l'événement",
    timeBeforeProtest: "Temps avant protestation",
    protestPeriodInProgress: "Période de protestation en cours",
    protestPeriodEnded: "La période de protestation est terminée",
    closeThisEvent: "Fermer cet événement",
    eventClosed: "Événement fermé",
    eventTerminated: "Epreuve completement terminee!",
    terminateEvent: "Terminer l'epreuve",
    resultsAreFinal: "Les resultats sont definitifs",
    closed: "Fermé",
    timeLimit: "Limite de temps",
    lastSavedPerformance: "Dernière performance enregistrée",
    warmUp: "Échauffement",
    transition: "Transition",
    realizedPerformance: "Performance réalisée (RP)",
    penalties: "Pénalités",
    card: "Carton",
    white: "Blanc",
    yellow: "Jaune",
    red: "Rouge",
    selectEventSession: "Sélectionner une session d'épreuve",
    noActiveSession: "Aucune session active",
    createEventSessionsHint: "Créez des sessions d'épreuve depuis l'onglet Inscriptions pour démarrer des événements en direct.",
    sessionInProgress: "Session en cours",
    passageList: "Liste de passage",
    passageOrder: "Ordre de passage",
    waitingRoom: "Salle d'attente",
    inProgress: "En cours",
    completed: "Terminé",
    unknown: "Inconnu",
    
    // Event Results
    eventResultsTitle: "Résultats des événements",
    eventResultsRankings: "Résultats & Classements",
    viewFinalResults: "Consultez les résultats finaux et classements des compétitions terminées et fermées.",
    selectCompetitionToView: "Veuillez sélectionner une compétition pour voir les résultats.",
    noCompletedEvents: "Aucun événement terminé ou fermé trouvé pour cette compétition.",
    viewRankings: "Voir le classement",
    downloadPDF: "Télécharger PDF",
    noResultsAvailable: "Aucun résultat disponible pour cet événement.",
    score: "Score",
    exportPdf: "Exporter en PDF",
    exportExcel: "Exporter en Excel",
    exportedOn: "Exporté le",
    filterByGender: "Filtrer par genre",
    all: "Tous",
    male: "Hommes",
    female: "Femmes",
    rank: "Rang",
    points: "Points",
    finalScore: "Score final",
    
    // Expiring Certificates
    expiringCertificates: "Certificats médicaux expirant",
    expiringCertificatesDesc: "Les apnéistes suivants ont des certificats médicaux expirant dans les 30 jours ou déjà expirés :",
    expires: "Expire",
    expired: "Expiré",
    daysLeft: "jours restants",
    
    // User Management
    userManagement: "Gestion des utilisateurs",
    users: "Utilisateurs",
    createUser: "Créer un utilisateur",
    editUser: "Modifier l'utilisateur",
    displayName: "Nom d'affichage",
    role: "Rôle",
    admin: "Administrateur",
    active: "Actif",
    inactive: "Inactif",
    resetPassword: "Réinitialiser le mot de passe",
    
    // Common
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    warning: "Attention",
    info: "Info",
    yes: "Oui",
    no: "Non",
    ok: "OK",
    close: "Fermer",
    search: "Rechercher",
    filter: "Filtrer",
    sortBy: "Trier par",
    actions: "Actions",
    view: "Voir",
    edit: "Modifier",
    create: "Créer",
    update: "Mettre à jour",
    gridView: "Vue grille",
    years: "ans",
    yrs: "ans",
    meters: "m",
    minutes: "min",
    seconds: "sec",
    
    // Settings
    settings: "Paramètres",
    globalSettings: "Paramètres globaux",
    globalSettingsDesc: "Configurer les paramètres de timing utilisés dans les événements en direct.",
    eventParameters: "Paramètres d'épreuve",
    durationPerPassageMinutes: "Durée par passage (min)",
    briefingDurationMinutes: "Durée du briefing (min)",
    warmupDurationMinutes: "Durée d'échauffement (min)",
    officialZoneDurationMinutes: "Durée de zone officielle (min)",
    durationBeforeProtestMinutes: "Délai avant protestation (min)",
    protestTimeDurationMinutes: "Durée de protestation (min)",
    saveSettings: "Enregistrer les paramètres",
    settingsSavedSuccess: "Paramètres enregistrés avec succès",
    saving: "Enregistrement...",
    competitionDetails: "Détails de la compétition",
    poolDetails: "Détails de la piscine",
    depth: "Profondeur",
    maxCapacity: "Capacité maximale",
    capacity: "Capacité",
    lanes: "Couloirs",
    trainingModule: "Module d'entraînement",
    management: "Gestion",
    laneMatrix: "Couloirs",
    tableView: "Tableau",
    lane: "Couloir",
    selectAquaticInfrastructure: "Sélectionner une infrastructure aquatique (optionnel)",
    selectInfrastructurePlaceholder: "Choisir une piscine pour remplir automatiquement...",
    none: "Aucun",
    language: "Langue",
    english: "Anglais",
    french: "Français",
    theme: "Thème",
    darkMode: "Mode sombre",
    lightMode: "Mode clair",
    
    // Disciplines (for dashboard event types)
    disciplinePool: "Piscine",
    disciplineDepth: "Profondeur",
    disciplineEndurance: "Endurance",
    disciplineEvent: "Épreuve",
    staticApnea: "Apnée statique",
    dynamicWithFins: "Dynamique avec palmes",
    dynamicNoFins: "Dynamique sans palmes",
    dynamicBifins: "Dynamique bipalmes",
    constantWeight: "Poids constant",
    constantWeightNoFins: "Poids constant sans palmes",
    constantWeightBifins: "Poids constant bipalmes",
    freeImmersion: "Immersion libre",
    endurance16x25: "Endurance 16x25m",
    endurance16x50: "Endurance 16x50m",
    variableWeight: "Poids variable",
    noLimits: "No Limit",
    
    // Event type detailed descriptions (French)
    descSTA: "L'apnée statique est la discipline la plus pure de l'apnée compétitive. L'athlète reste immobile, généralement face vers le bas dans l'eau à la surface, et retient son souffle le plus longtemps possible. Cette épreuve se déroule en piscine et met l'accent sur la gestion mentale, la relaxation profonde et l'optimisation de la consommation d'oxygène. C'est souvent la première discipline pratiquée par les débutants car elle leur permet de développer la conscience corporelle et de comprendre leurs limites sans le stress du mouvement. Les records du monde actuels dépassent 11 minutes pour les hommes et 9 minutes pour les femmes.",
    descDYN: "L'apnée dynamique consiste à parcourir la plus grande distance possible en piscine, en une seule inspiration, à l'aide d'une monopalme. L'athlète se déplace sous l'eau en position horizontale, généralement entre un et deux mètres de profondeur. Cette discipline combine l'endurance respiratoire avec l'efficacité technique dans la propulsion palmée. La monopalme, inspirée de la nage du dauphin, optimise la propulsion tout en minimisant la dépense énergétique. Les meilleurs apnéistes du monde parcourent plus de 300 mètres en une seule inspiration, transformant la piscine en une véritable arène de performance aquatique.",
    descDNF: "L'apnée dynamique sans palmes représente la forme la plus pure de propulsion en apnée, où l'athlète progresse uniquement par les mouvements des bras, généralement en utilisant la brasse sous-marine. Cette discipline nécessite une technique de nage parfaitement maîtrisée pour minimiser la résistance de l'eau et économiser l'oxygène. Sans l'aide des palmes, chaque mouvement doit être calculé et fluide. C'est une épreuve particulièrement exigeante qui révèle la véritable efficacité aquatique de l'apnéiste. Les records du monde sont d'environ 240 mètres pour les hommes et 185 mètres pour les femmes, démontrant l'exploit remarquable que représente cette discipline.",
    descDYNBF: "L'apnée dynamique avec bipalmes suit les mêmes principes que l'apnée dynamique, mais utilise deux palmes traditionnelles au lieu d'une monopalme. Cette variante offre une alternative technique différente, avec des battements de palmes alternés qui ressemblent davantage à la nage classique. Les bipalmes offrent une méthode de propulsion plus accessible pour les débutants tout en permettant d'excellentes performances pour les athlètes expérimentés. Cette discipline nécessite une coordination précise et une ondulation corporelle efficace. Les performances mondiales avec bipalmes atteignent environ 280-290 mètres, légèrement moins qu'avec la monopalme en raison d'une efficacité énergétique différente.",
    descCWT: "Le poids constant est la discipline reine de l'apnée profonde. L'apnéiste descend et remonte avec le même poids (lest) tout au long de la plongée, en utilisant une monopalme pour la propulsion. Cette épreuve exige une condition physique exceptionnelle, une technique de palmage parfaite et une gestion mentale irréprochable. L'athlète doit optimiser sa descente avec une chute libre passive après la phase initiale de palmage, puis remonter activement en luttant contre la flottabilité négative des profondeurs. Les records du monde actuels dépassent 130 mètres pour les hommes et 105 mètres pour les femmes, repoussant constamment les limites de la physiologie humaine.",
    descCNF: "Le poids constant sans palmes est considéré comme la discipline la plus pure et la plus difficile de l'apnée profonde. L'athlète descend et remonte en utilisant uniquement la force de ses bras et de ses jambes, sans aucune assistance de palmes, tout en maintenant le même lest tout au long de la plongée. Cette discipline exige une technique de nage sous-marine exemplaire, généralement en brasse, et une gestion hydrodynamique parfaite. Chaque mouvement doit être calculé pour économiser l'oxygène tout en progressant efficacement. C'est l'épreuve qui se rapproche le plus de l'apnée ancestrale et qui demande le plus grand contrôle corporel. Les records du monde sont d'environ 102 mètres pour les hommes et 73 mètres pour les femmes.",
    descCWTBF: "Le poids constant avec bipalmes suit le même principe que le poids constant classique, mais l'apnéiste utilise deux palmes traditionnelles au lieu d'une monopalme. Cette variante offre une alternative technique intéressante, notamment pour les athlètes qui préfèrent les battements de palmes alternés ou qui n'ont pas accès à une monopalme. Les bipalmes offrent également une meilleure stabilité pendant la descente et la remontée, ce qui peut être un avantage pour certains apnéistes. Bien que moins répandue que la version monopalme dans les compétitions internationales, cette discipline reste populaire dans certains pays et permet des performances remarquables, avec des records approchant les 115-120 mètres de profondeur.",
    descFIM: "L'immersion libre est une discipline de profondeur où l'apnéiste descend et remonte le long d'une ligne verticale en se tirant uniquement avec les bras, sans utiliser de palmes ni aucun système de propulsion. Cette technique, proche de l'apnée traditionnelle des pêcheurs, offre une descente contrôlée et économe en énergie. L'athlète peut se concentrer pleinement sur la compensation des oreilles et la gestion de la flottabilité. Le contact constant avec la ligne fournit également un point de repère rassurant et permet un contrôle précis de la vitesse. Les records du monde dépassent 125 mètres de profondeur, faisant de cette discipline un excellent terrain d'entraînement pour apprendre à gérer la pression et la profondeur.",
    desc16x25: "Une épreuve d'endurance où les athlètes complètent 16 traversées consécutives de 25 mètres sous l'eau avec de courts intervalles de récupération. Teste à la fois la capacité aérobique et la capacité d'apnée.",
    desc16x50: "Une épreuve d'endurance où les athlètes complètent 16 traversées consécutives de 50 mètres sous l'eau avec de courts intervalles de récupération. Un test exigeant d'endurance et de force mentale.",
    
    // User Management
    userManagementTitle: "Gestion des accès utilisateurs",
    createNewUser: "Créer un nouvel utilisateur",
    editUserTitle: "Modifier l'utilisateur",
    userCreatedSuccess: "Utilisateur créé avec succès",
    userUpdatedSuccess: "Utilisateur mis à jour avec succès",
    userDeletedSuccess: "Utilisateur supprimé avec succès",
    confirmDeleteUser: "Êtes-vous sûr de vouloir supprimer cet utilisateur?",
    preferredLanguage: "Langue préférée",
    accountStatus: "Statut du compte",
    lastLogin: "Dernière connexion",
    neverLoggedIn: "Jamais connecté",
    manageUserAccounts: "Gérer les comptes utilisateurs et les permissions.",
    newPassword: "Nouveau mot de passe (laisser vide pour conserver l'actuel)",
    readOnly: "Lecture seule",
    standard: "Standard",
    fullAccess: "Accès complet",
    
    // Calendar View
    selectDate: "Sélectionner une date",
    hasSession: "Séance prévue",
    selected: "Sélectionné",
    sessionsFor: "Séances du",
    selectDateToViewSessions: "Sélectionnez une date pour voir les séances",
    noSessionsOnDate: "Aucune séance d'entraînement à cette date",
    clickDateToView: "Cliquez sur une date pour voir ou créer des séances d'entraînement",
    
    // Scoring rules
    scoringPointsPer5Seconds: "1 point par 5 secondes",
    scoringPointsPerMeter: "0,5 point par mètre",
    
    // Freedivers Filters
    filterByNationality: "Filtrer par nationalité",
    filterByGenderFreedivers: "Filtrer par sexe",
    allNationalities: "Toutes les nationalités",
    allGenders: "Tous les sexes",
    viewPerformances: "Voir les performances",
    searchFreedivers: "Rechercher des apnéistes...",
    
    // Medical Certificate
    medicalCertificate: "Certificat médical",
    certificateStatus: "Statut du certificat",
    certificateValid: "Valide",
    certificateInvalid: "Invalide / Expiré",
    certificateNotUploaded: "Non téléchargé",
    uploadCertificate: "Télécharger le certificat",
    replaceCertificate: "Remplacer le certificat",
    previewCertificate: "Aperçu du certificat",
    downloadCertificate: "Télécharger le certificat",
    removeCertificate: "Supprimer le certificat",
    certificateUploadDate: "Date de téléchargement",
    medicalCertificateManagement: "Gestion du certificat médical",
    markAsValid: "Marquer comme valide",
    markAsInvalid: "Marquer comme invalide",
    pdfFilesOnly: "Fichiers PDF uniquement (max 5MB)",
    
    // CSV Import
    importCSV: "Importer CSV",
    downloadTemplate: "Télécharger le modèle",
    importFreedivers: "Importer des apnéistes",
    csvImportResults: "Résultats de l'importation",
    totalProcessed: "Total traité",
    totalCreated: "Créés avec succès",
    totalErrors: "Erreurs",
    importSuccess: "Importation terminée avec succès",
    importError: "Erreur lors de l'importation",
    row: "Ligne",
    selectCSVFile: "Sélectionnez un fichier CSV à importer",
    csvFileSelected: "Fichier sélectionné",
    
    // Certificate Dates
    certificateStartDate: "Date de début",
    certificateExpiryDate: "Date d'expiration",
    certificateUploaded: "Certificat téléchargé",
    previewPDF: "Aperçu PDF",
    
    // Freediving Levels
    freedivingLevels: "Niveaux d'Apnée",
    freedivingLevelsDescription: "Niveaux de certification par organisme pour les organisations d'apnée mondiales",
    agencies: "Organismes",
    levels: "niveaux",
    beginnerLevels: "Niveaux Débutant",
    intermediateLevels: "Niveaux Intermédiaire",
    advancedLevels: "Niveaux Avancé",
    expertLevels: "Niveaux Expert",
    instructorLevels: "Niveaux Instructeur",
    otherLevels: "Autres Niveaux",
    selectCertificationLevel: "Sélectionner le niveau de certification",
    noCertificationAgency: "Veuillez d'abord sélectionner un organisme de certification",
    
    // Dashboard Calendar & Certificates
    weeklyCalendar: "Calendrier Hebdomadaire d'Entraînement",
    today: "Aujourd'hui",
    noSessions: "Aucune session",
    totalSessions: "sessions au total",
    thisWeek: "cette semaine",
    noTrainingSessionsYet: "Aucune session d'entraînement programmée",
    more: "de plus",
    expiringCertificatesDesc60: "Les apnéistes suivants ont des certificats médicaux expirant dans les 60 jours ou déjà expirés:",
    days: "jours",
    
    // Exercise Import & Attendance
    importExercises: "Importer des exercices",
    importSessions: "Importer des séances",
    downloadTemplateFirst: "Téléchargez le fichier modèle, remplissez-le avec vos exercices, puis téléchargez-le ici.",
    selectExcelFile: "Sélectionner un fichier Excel ou CSV",
    importResults: "Résultats de l'importation",
    processed: "Traités",
    created: "Créés",
    errors: "Erreurs",
    attendance: "Présence",
    present: "Présent",
    absent: "Absent",
    excused: "Excusé",
    late: "En retard",
    pending: "En attente",
    noParticipants: "Aucun participant assigné",
    upcomingSessions: "Sessions à venir",
    sessionReminder: "Rappel de session",
    tomorrow: "Demain",
    // Capacity alerts
    capacityAlerts: "Alertes de capacité",
    full: "Complet",
    nearFull: "Presque complet",
    filling: "En cours de remplissage",
    available: "Disponible",
    capacityAlertNote: "Les sessions à 80%+ de capacité sont affichées ci-dessus",
    // Exercise Library
    distanceDuration: "Dist./Dur.",
    importExercises: "Importer des exercices",
    importSessions: "Importer des séances",
    step: "Étape",
    clickToSelectFile: "Cliquez pour sélectionner un fichier",
    importing: "Importation...",
    // Address fields
    addressInformation: "Informations d'adresse",
    phoneNumber: "Numéro de téléphone",
    addressNumber: "Numéro",
    addressType: "Type",
    addressName: "Nom de rue",
    city: "Ville",
    stateProvince: "État/Province",
    postalCode: "Code postal",
    addressCountry: "Pays",
    selectType: "Sélectionner le type",
    // Delete confirmation
    confirmDelete: "Confirmer la suppression",
    confirmDeleteFreediverMessage: "Êtes-vous sûr de vouloir supprimer cet apnéiste? Cette action est irréversible.",
    deleting: "Suppression...",
    delete: "Supprimer",
    errorDeletingFreediver: "Erreur lors de la suppression de l'apnéiste. Veuillez réessayer.",
    cannotDeleteWithRegistrations: "Impossible de supprimer un apnéiste avec des inscriptions aux événements. Veuillez d'abord désinscrire de tous les événements.",
    // Registration
    confirmUnregister: "Confirmer la désinscription",
    confirmUnregisterMessage: "Êtes-vous sûr de vouloir désinscrire cet apnéiste de l'événement?",
    unregister: "Désinscrire",
    errorUnregistering: "Erreur lors de la désinscription. Veuillez réessayer.",
    noRegistrationsYet: "Aucune inscription pour le moment",
    startByRegistering: "Commencez par inscrire des apnéistes aux événements des compétitions.",
    // Calendar
    sessionsFor: "Sessions du",
    noSessions: "Aucune session",
    // Live Event Management
    clearOrphanSessions: "Supprimer sessions orphelines",
    forceStartNow: "Demarrer maintenant",
    activeEventBanner: "Evenement actif",
    goToLiveEvent: "Voir l'evenement",
    // Penalty Calculator
    penaltyCalculator: "Calculateur de penalites",
    announcedPerformance: "Performance annoncee (PA)",
    realizedPerformance: "Performance realisee (PR)",
    addPenalties: "Ajouter penalites",
    activePenalties: "Penalites actives",
    surfaceProtocol: "Protocole de surface",
    timeLimit: "Temps limite",
    savePerformance: "Enregistrer la performance",
    // Dashboard Live Event
    liveEventActive: "Evenement en direct en cours",
    viewLiveEvent: "Voir l'evenement en direct",
    spectatorView: "Vue Spectateur",
    spectator: "Spectateur",
    elapsed: "Ecoulement",
    // Simulation Mode
    eventLiveSimulation: "Simulation d'evenement en direct",
    eventLiveSimulationDesc: "Activer le mode simulation pour tester les evenements en direct avec la fonction de saut rapide",
    simulationModeActive: "Mode Simulation Actif",
    simulationModeHint: "Utilisez \"Passer au compte à rebours officiel\" pour avancer rapidement",
    skipToNextCountdown: "Passer au suivant",
    resetActiveSession: "Reinitialiser la session",

    // Organizations & Memberships
    organizations: "Organisation(s)",
    organizationsList: "Organisations",
    addOrganization: "Ajouter une organisation",
    editOrganization: "Modifier l'organisation",
    organizationName: "Nom de l'organisation",
    organizationType: "Type",
    membershipType: "Type d'adhesion",
    addressNumber: "Numero",
    street: "Rue",
    city: "Ville",
    province: "Province",
    country: "Pays",
    postalCode: "Code postal",
    validityPeriodStart: "Debut de validite",
    validityPeriodEnd: "Fin de validite",
    validityYears: "Annee(s) de validite",
    validity: "Validite",
    website: "Site web",
    phone: "Telephone",
    noOrganizations: "Aucune organisation",
    addOrganizationHint: "Cliquez sur \"Ajouter une organisation\" pour commencer",
    addMember: "Ajouter un membre",
    addMemberTo: "Ajouter un membre a",
    searchFreediver: "Rechercher un plongeur",
    selected: "Selectionne",
    noMembers: "Aucun membre enregistre",
    noResults: "Aucun resultat",
    valid: "Valide",
    expired: "Expire",
    expiringSoon: "Expire bientot",
    active: "Actif",
    missing: "Manquant",
    medicalCertificate: "Cert. med.",
    period: "Periode",
    create: "Creer",
    update: "Mettre a jour",
    sex: "Sexe",
    nationality: "Nat.",

    // RBAC Module Groups
    moduleGroupCompetitions: "Competitions",
    moduleGroupFreedivers: "Plongeurs",
    moduleGroupTraining: "Entrainement",
    moduleGroupManagement: "Gestion",
    moduleGroupReference: "Reference",
    moduleCompetitions: "Competitions",
    moduleRegistrations: "Inscriptions",
    moduleLiveEvents: "Evenements Live",
    moduleEventResults: "Resultats",
    moduleFreedivers: "Plongeurs",
    moduleFollowUp: "Suivi",
    modulePerformanceComparison: "Comparaison",
    moduleTrainingSessions: "Sessions d'entrainement",
    moduleExerciseLibrary: "Exercices",
    moduleSessionBuilder: "Constructeur de session",
    moduleApneaTables: "Tables d'apnée",
    moduleOrganizations: "Organisations",
    moduleAquaticInfrastructure: "Infrastructures aquatiques",
    allowedModules: "Modules autorises",
    assignedOrganizations: "Organisations assignees",
    selectAll: "Tout selectionner",
    deselectAll: "Tout deselectionner",
    allOrganizations: "Toutes les organisations (admin)",
    noOrganizationAssigned: "Aucune organisation assignee",
    selectOrganizations: "Selectionner les organisations...",
    accessAllModules: "Admin : acces complet a tous les modules",
    accessAllOrgs: "Admin : acces a toutes les organisations",
    page: "Page",
    of: "de",
    permissions: "Permissions",
    copyRightsFrom: "Copier les droits de :",
    selectUser: "Choisir un usager...",
    pdfImportDescription: "Importez un plan d'entrainement en PDF. L'IA analysera le document et creera automatiquement la seance avec tous les exercices.",
    selectPdfFile: "Selectionner un plan d'entrainement PDF",
    aiAnalyzing: "L'IA analyse le document...",
    analyzePdf: "Analyser le PDF",
    importSuccess: "Import reussi"
  }
};

export default translations;
